export default {
    values: {
        'A temporal lollipop is a way of representing some numerical value that occurs over time with a thin bar and a circle on top of it. The position of the bar will represent the timestamp of the event and its height represents its value.':
            'Um gráfico de Lollipop Temporal é uma forma de representar um valor numérico que ocorre ao longo do tempo com uma barra fina e um círculo em cima dela. A posição da barra representará o timestamp do evento e sua altura representará seu valor.',
        'A histogram is an approximate representation of the distribution of numerical data.':
            'Um histograma é uma representação aproximada da distribuição de dados numéricos.',
        'state timeline description':
            'Estados que ocorrem ao longo do tempo representados numa linha do tempo. O gráfico espera que o nome dos estados venha no campo valor dos eventos.'
    }
}
